// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@awc/XDL/Utilities";
import { rfqQuoteDetailsQuoteLineCalculatorStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuoteLineCalculatorRow";
import { css } from "styled-components";

rfqQuoteDetailsQuoteLineCalculatorStyles.qtyCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        padding-top: 10px;
        min-width: 300px;
        ${xScreen("lte", "sm")} {
            height: auto;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceBreakWithCalculatorRow = {
    css: css`
        vertical-align: top;
    `,
    evenRowCss: css`
        background: transparent;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        text-align: right;
        padding-top: 10px;
        min-width: unset;
        ${xScreen("lte", "sm")} {
            height: auto;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.removePriceBreakLink = {
    css: css`
        margin-left: auto;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.buttonsCell = {
    css: css`
        height: 60px;
        border-bottom: none;
        text-align: right;
        padding-top: 20px;
        min-width: auto;
        ${xScreen("lte", "sm")} {
            height: auto;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.calculatorCell = {
    css: css`
        display: block;
        position: absolute;
        width: 100%;
        height: 60px;
        padding-top: 10px;
        border: none;
        left: 0;
        min-width: 300px;
        max-width: 300px;
        ${xScreen("lte", "sm")} {
            position: static;
            height: auto;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.methodGridItem = {
    width: 7,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.percentGridItem = {
    width: 3,
    align: "bottom",
};

rfqQuoteDetailsQuoteLineCalculatorStyles.percentTextField = {
    cssOverrides: {
        formField: css`
            width: 60px;
            min-width: 40px;
        `,
    },
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceBreakRow = {
    css: css`
        height: unset;
        vertical-align: top;
        row-gap: 12px;
    `,
    evenRowCss: css`
        background: transparent;
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.toLabelText = {
    css: css`
        white-space: nowrap;
        ${xScreen("gt", "sm")} {
            margin: 0 10px;
        }
    `,
};

rfqQuoteDetailsQuoteLineCalculatorStyles.priceBreakWithCalculatorRow = {
    css: css`
        height: 140px;
        vertical-align: top;

        ${xScreen("lte", "sm")} {
            height: 100%;
            max-height: 210px;
            row-gap: 8px;
        }
    `,
    evenRowCss: css`
        background: transparent;
    `,
};
